<!-- Search and Filter Section -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search for employees by name"
    [(searchTerm)]="shiftScheduleSearchTerm"
    (searchChange)="onShiftScheduleSearchChange()"
    iconSize="small">
  </app-searchbar>
  <div class="filter-container">
    <div class="period-section">
      <span class="period-label">Period</span>
      <app-period-dropdown
        [options]="periodOptions"
        [isOpen]="showPeriodDropdown"
        [selectedPeriod]="selectedPeriod"
        [clearText]="'Clear'"
        [primaryButtonText]="'Apply'"
        [secondaryButtonText]="'Cancel'"
        [customWeekData]="customWeekData"
        (toggle)="onTogglePeriodDropdown()"
        (select)="onSelectPeriod($event)"
        (apply)="onApplyPeriod($event)"
        (clear)="onClearPeriod()"
        (close)="onClosePeriodDropdown()"
        (customWeekChange)="onCustomWeekChange($event)">
      </app-period-dropdown>
    </div>
    <app-add-button class="desktop-buttons" buttonText="Break Settings" variant="secondary" iconType="break-settings" (buttonClick)="onBreakSettings()"></app-add-button>
    <app-add-button class="desktop-buttons" buttonText="Create Schedule" variant="primary" (buttonClick)="onCreateSchedule()"></app-add-button>
    <div class="buttons-row">
      <app-add-button class="mobile-buttons" buttonText="Break Settings" variant="secondary" iconType="break-settings" (buttonClick)="onBreakSettings()"></app-add-button>
      <app-add-button class="mobile-buttons" buttonText="Create Schedule" variant="primary" (buttonClick)="onCreateSchedule()"></app-add-button>
    </div>
  </div>
</div>

<!-- Shimmer Loading -->
<div *ngIf="loadingShiftSchedules" class="table-section">
  <app-loading-table-shimmer [columns]="shimmerColumns" [rows]="5"></app-loading-table-shimmer>
</div>

<!-- Shift Schedule Table -->
<div class="table-section" *ngIf="!loadingShiftSchedules && filteredShiftSchedules.length > 0">
  <div class="table-container">
    <div class="table-scroll-wrapper" #shiftScheduleTableScrollWrapper>
      <table class="shift-schedule-table">
        <thead>
          <tr>
            <th>Employee Name</th>
            <th>Shifts</th>
            <th>Working Days / Timings</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let schedule of filteredShiftSchedules; trackBy: trackByScheduleId; let i = index"
              class="schedule-row"
              [style.animation-delay]="(i * 0.05) + 's'"
              [attr.data-index]="i">
            <td>
              <div class="employee-info">
                <div class="employee-avatar">
                  <span class="avatar-initials">{{ getEmployeeInitialsFromName(schedule.employee_name) }}</span>
                </div>
                <div class="employee-details">
                  <div class="employee-name">{{ schedule.employee_name }}</div>
                </div>
              </div>
            </td>
            <td><div class="shift-name">{{ schedule.shift_name }}</div></td>
            <td><div class="working-days-timings">{{ formatWorkingDaysTimings(schedule.working_days) }}</div></td>
            <td>
              <div class="actions-cell" (click)="$event.stopPropagation()">
                <button class="actions-button" (click)="toggleShiftScheduleActionsDropdown($event, schedule.schedule_id)">
                  <ng-container *ngTemplateOutlet="threeDotsIcon"></ng-container>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Empty State -->
<div *ngIf="!loadingShiftSchedules && filteredShiftSchedules.length === 0" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    [title]="shiftScheduleSearchTerm ? 'No shift schedules found' : 'No shift scheduled!'"
    [description]="shiftScheduleSearchTerm ? 'Try adjusting your search criteria' : 'Please schedule a shift to continue.'"
    [actionText]="'Add Schedule'"
    [showAction]="true"
    [actionClick]="getCreateScheduleAction()">
  </app-empty-result>
</div>

<!-- Pagination -->
<div class="pagination-wrapper" *ngIf="filteredShiftSchedules.length > 0">
  <app-pagination-bar [paginationData]="paginationData" (pageChange)="onPageChange($event)" (itemsPerPageChange)="onItemsPerPageChange($event)"></app-pagination-bar>
</div>

<!-- Modals -->
<app-schedule-shift-modal
  [isOpen]="showScheduleShiftModal"
  (closeModal)="onCloseScheduleShiftModal()"
  (saveSchedule)="onSaveScheduleShift($event)">
</app-schedule-shift-modal>

<app-edit-schedule-modal
  [isOpen]="showEditScheduleModal"
  [scheduleData]="selectedScheduleForEdit"
  (closeModal)="onCloseEditScheduleModal()"
  (saveSuccess)="onEditScheduleSaveSuccess()">
</app-edit-schedule-modal>

<app-break-settings-modal
  [isOpen]="showBreakSettingsModal"
  (closeModal)="onCloseBreakSettingsModal()"
  (saveSettings)="onSaveBreakSettings($event)">
</app-break-settings-modal>

<!-- Global Shift Schedule Actions Dropdown -->
<div class="actions-dropdown-menu"
     *ngIf="activeShiftScheduleActionsDropdown && selectedShiftScheduleForDropdown"
     [id]="'shift-schedule-dropdown-' + activeShiftScheduleActionsDropdown">
  <div class="dropdown-item" (click)="onEditShiftSchedule(selectedShiftScheduleForDropdown!)">
    <div class="dropdown-content">
      <span class="dropdown-text">Edit</span>
      <img src="/assets/images/pencil.svg" alt="Edit" class="dropdown-icon" width="14" height="14">
    </div>
  </div>
</div>

<!-- Three-dot icon template -->
<ng-template #threeDotsIcon>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8.66667C8.36819 8.66667 8.66667 8.36819 8.66667 8C8.66667 7.63181 8.36819 7.33333 8 7.33333C7.63181 7.33333 7.33333 7.63181 7.33333 8C7.33333 8.36819 7.63181 8.66667 8 8.66667Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 4C8.36819 4 8.66667 3.70152 8.66667 3.33333C8.66667 2.96514 8.36819 2.66667 8 2.66667C7.63181 2.66667 7.33333 2.96514 7.33333 3.33333C7.33333 3.70152 7.63181 4 8 4Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 13.3333C8.36819 13.3333 8.66667 13.0349 8.66667 12.6667C8.66667 12.2985 8.36819 12 8 12C7.63181 12 7.33333 12.2985 7.33333 12.6667C7.33333 13.0349 7.63181 13.3333 8 13.3333Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</ng-template>
